<template>
  <div class="ImageView">
    <div id="form-div">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-10">
          <span>{{ $t('wheelAnalysis.imageView.optionalUploadPrompt') }}</span>

          <br /><br />

          <MDBFile
              :disabled="!editMode"
              v-model="imageFile"
              :label="$t('wheelAnalysis.imageView.imageLabel')"
              @change="uploadImage"
          />

          <br />

          <img :src="previewImage" class="preview-image" />

          <br />
          <br />
          <br />
        </div>

        <div class="sidebar-instructions px-4">
          {{ $t('wheelAnalysis.imageView.guidanceNote') }}
        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_ImageView.js" lang="js"></script>
<style src="./_ImageView.less" lang="less" scoped></style>
